import { ImageScaleView, ImageScaleViewOpts } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import i18n from 'src/lib/i18n/i18n';

export default class Match2SocialContinueMovesPanel extends ImageScaleView {
  private maxCount: LangBitmapFontTextView;
  private message: LangBitmapFontTextView;

  constructor(
    opts: Omit<
      ImageScaleViewOpts,
      'image' | 'width' | 'height' | 'centerOnOrigin' | 'centerAnchor'
    >,
  ) {
    super({
      ...opts,
      width: 253,
      height: 213,
      centerOnOrigin: true,
      centerAnchor: true,
      image: 'assets/ui/match2/common/panel_pinch.png',
    });

    let offsetX = 40;

    new ImageScaleView({
      superview: this,
      image: `assets/ui/match2/common/pinch_moves.png`,
      width: 208,
      height: 217,
      centerOnOrigin: true,
      centerAnchor: true,
      x: this.style.width * 0.5 - offsetX,
      y: this.style.height * 0.5 - 30,
      scale: 0.55,
    });

    new LangBitmapFontTextView({
      superview: this,
      font: 'Title',
      color: '#FFFFFF',
      size: 45,
      x: this.style.width * 0.5 + 20 - offsetX,
      y: this.style.height * 0.5 - 30,
      centerOnOrigin: true,
      centerAnchor: true,
      localeText: () => '+1',
      verticalAlign: 'center',
      align: 'center',
    });

    this.maxCount = new LangBitmapFontTextView({
      superview: this,
      font: 'Title',
      color: '#FFB14A',
      size: 50,
      x: this.style.width * 0.5 + 60,
      y: this.style.height * 0.5 - 55,
      centerOnOrigin: true,
      centerAnchor: true,
      verticalAlign: 'center',
      align: 'center',
    });

    this.message = new LangBitmapFontTextView({
      superview: this,
      font: 'Body',
      color: '#BF8147',
      size: 20,
      x: this.style.width * 0.5,
      y: 170,
      centerOnOrigin: true,
      centerAnchor: true,
      width: this.style.width - 50,
      height: 70,
      verticalAlign: 'center',
      align: 'center',
    });
  }

  public init(amount: number) {
    this.maxCount.localeText = () => `X${amount}`;
    this.message.localeText = () => i18n('match2.socialContinue.inviteMessage');
  }
}
